import { render, staticRenderFns } from "./DashboardSkeleton.vue?vue&type=template&id=5290fee0&scoped=true&"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js&"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSkeleton.vue?vue&type=style&index=0&id=5290fee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5290fee0",
  null
  
)

export default component.exports